// src/pages/TicketLookup/types.ts
// Khớp với TicketLookupResponse từ backend (TicketService.Contacts.Dtos.TicketLookupResponse)

export interface TicketInfo {
  id: number;
  lotteryPeriodId: number;
  ticketNumber: string;
  symbol: string;
  seri?: string | null;
}

export interface PlanInfo {
  planCode: string;
  expectedDrawDate: string;
}

export interface WonPrize {
  prizeLevel: string;
  prizeAmount: number;
  winningNumber: string;
}

export interface ResultInfo {
  hasResult: boolean;
  isWinning: boolean;
  prizeLevel?: string | null;
  prizeAmount?: number | null;
  winningNumber?: string | null;
  drawStatus: 'pending' | 'completed' | string;
  actualDrawDate?: string | null;
  wonPrizes: WonPrize[];
}

export interface TicketLookupResponse {
  success: boolean;
  ticket?: TicketInfo | null;
  plan?: PlanInfo | null;
  result?: ResultInfo | null;
  errorCode?: string | null;
  errorMessage?: string | null;
  timestamp: string;
  requestId: string;
}

export const LOOKUP_ERROR_MESSAGES: Record<string, string> = {
  INVALID_SIGNATURE: 'Mã QR không hợp lệ hoặc đã bị thay đổi.',
  TICKET_NOT_FOUND: 'Không tìm thấy thông tin vé này trong hệ thống.',
  INVALID_REQUEST: 'Đường dẫn tra cứu không hợp lệ.',
  INTERNAL_ERROR: 'Hệ thống đang gặp sự cố. Vui lòng thử lại sau.',
};
